import * as pathToRegexp from 'path-to-regexp'
import { getSelectiveUrl } from 'common/services/finder/menu'

export enum SubVertical {
  HOME = 'HOME',
  DEPARTMENT = 'DEPARTMENT',
  OUTLET = 'OUTLET',
  STYLE = 'STYLE',
  FASHION_BRAND = 'FASHION_BRAND',
  DESIGNER = 'DESIGNER',
  BEAUTY = 'BEAUTY',
  HOME_LIVING = 'HOME_LIVING',
  HANDMADE = 'HANDMADE',
  STATIONERY = 'STATIONERY',
  DIRECT_FARM = 'DIRECT_FARM',
  LOCAL_FOOD = 'LOCAL_FOOD',
  TRADITIONAL_ALCOHOL = 'TRADITIONAL_ALCOHOL',
  HOME_MEAL = 'HOME_MEAL',
  KIDS = 'KIDS',
  PET = 'PET',
  PLAY = 'PLAY',
  ART = 'ART',
  SOCIAL = 'SOCIAL',
  LUCKTO = 'LUCKTO',
  GIFT = 'GIFT',
  FOREIGN = 'FOREIGN',
  PLAN = 'PLAN',
  BEST = 'BEST',
  SELECTIVE = 'SELECTIVE',
}

export enum Vertical {
  HOME = 'HOME',
  DEPARTMENT = 'DEPARTMENT',
  OUTLET = 'OUTLET',
  STYLE = 'STYLE',
  DESIGNER = 'DESIGNER',
  BEAUTY = 'BEAUTY',
  LIVING = 'LIVING',
  FRESH = 'FRESH',
  KIDS = 'KIDS',
  PET = 'PET',
  PLAY = 'PLAY',
  ART = 'ART',
  HOTDEAL = 'HOTDEAL',
  GIFT = 'GIFT',
  FOREIGN = 'FOREIGN',
  PLAN = 'PLAN',
  BEST = 'BEST',
  SELECTIVE = 'SELECTIVE',
}

export interface SubVerticalConfig {
  vertical: Vertical
  name: string
  path: string
  eventTitle?: string
  eventNewsTitle?: string
  eventNewsLandingUrl?: Function
  fullName?: string
}

type SubVerticalConfigType = { [key in SubVertical]: SubVerticalConfig }

export const subVerticalConfig: SubVerticalConfigType = {
  HOME: {
    vertical: Vertical.HOME,
    name: '홈',
    path: '/home',
  },
  DEPARTMENT: {
    vertical: Vertical.DEPARTMENT,
    name: '백화점윈도',
    path: '/department',
    eventNewsTitle: '지점소식',
    eventNewsLandingUrl: (storeId, branchId, newsId) => {
      return `branch/${branchId}/news/${newsId}`
    },
  },
  OUTLET: {
    vertical: Vertical.OUTLET,
    name: '아울렛윈도',
    path: '/outlet',
    eventNewsTitle: '지점소식',
    eventNewsLandingUrl: (storeId, branchId, newsId) => {
      return `branch/${branchId}/news/${newsId}`
    },
  },
  STYLE: {
    vertical: Vertical.STYLE,
    name: '로드샵',
    path: '/style',
  },
  FASHION_BRAND: {
    vertical: Vertical.STYLE,
    name: '브랜드관',
    path: '/fashionbrand',
  },
  DESIGNER: {
    vertical: Vertical.DESIGNER,
    name: '디자이너윈도',
    path: '/designer',
  },
  BEAUTY: {
    vertical: Vertical.BEAUTY,
    name: '뷰티윈도',
    path: '/beauty',
  },
  HOME_LIVING: {
    vertical: Vertical.LIVING,
    name: '홈&데코',
    path: '/homeliving',
  },
  HANDMADE: {
    vertical: Vertical.LIVING,
    name: '창작공방',
    path: '/handmade',
  },
  STATIONERY: {
    vertical: Vertical.LIVING,
    name: '문방구',
    path: '/stationery',
  },
  DIRECT_FARM: {
    vertical: Vertical.FRESH,
    name: '산지직송',
    path: '/directfarm',
    eventTitle: 'EVENT',
  },
  LOCAL_FOOD: {
    vertical: Vertical.FRESH,
    name: '지역명물',
    path: '/localfood',
    eventTitle: 'EVENT',
  },
  TRADITIONAL_ALCOHOL: {
    vertical: Vertical.FRESH,
    name: '전통주',
    path: '/traditionalalcohol',
    eventTitle: '소식/기획전',
    eventNewsLandingUrl: (storeId, branchId, newsId) => {
      return `${getSubVerticalPath(SubVertical.TRADITIONAL_ALCOHOL)}/stores/${storeId}/news/${newsId}`
    },
  },
  HOME_MEAL: {
    vertical: Vertical.FRESH,
    name: '쿠킹박스',
    path: '/homemeal',
    eventTitle: '이벤트',
  },
  KIDS: {
    vertical: Vertical.KIDS,
    name: '키즈윈도',
    path: '/kids',
  },
  PET: {
    vertical: Vertical.PET,
    name: '펫윈도',
    path: '/pet',
  },
  PLAY: {
    vertical: Vertical.PLAY,
    name: '플레이윈도',
    path: '/play',
  },
  ART: {
    vertical: Vertical.ART,
    name: '아트윈도',
    path: '/art',
    eventTitle: '테마',
    eventNewsTitle: '갤러리소식',
    eventNewsLandingUrl: (storeId, branchId, newsId) => {
      return `${getSubVerticalPath(SubVertical.ART)}/stores/${storeId}/news/${newsId}`
    },
  },
  SOCIAL: {
    vertical: Vertical.HOTDEAL,
    name: '소셜베스트',
    path: '/social',
  },
  LUCKTO: {
    vertical: Vertical.HOTDEAL,
    name: '럭키투데이',
    path: '/luckto',
  },
  GIFT: {
    vertical: Vertical.GIFT,
    name: '선물',
    path: '/gift',
  },
  FOREIGN: {
    vertical: Vertical.FOREIGN,
    name: '해외직구',
    fullName: '네이버 해외직구',
    path: '/foreign',
    eventNewsTitle: '아울렛NOW',
    eventNewsLandingUrl: (storeId, branchId, newsId) => {
      return `${getSubVerticalPath(SubVertical.FOREIGN)}/stores/${storeId}/news/${newsId}`
    },
  },
  PLAN: {
    vertical: Vertical.PLAN,
    name: '기획전',
    path: '/plan',
  },
  BEST: {
    vertical: Vertical.BEST,
    name: 'BEST',
    path: '/best',
  },
  SELECTIVE: {
    vertical: Vertical.SELECTIVE,
    name: '셀렉티브',
    path: '',
  },
}

export interface VerticalConfig {
  subVerticals: SubVertical[]
  name?: string
  fullName?: string
  path?: string
  isWindow?: boolean
  homeUrl?: {
    mobile?: string
    pc?: string
  }
  specialEventTitle?: string
}

type VerticalConfigType = { [key in Vertical]: VerticalConfig }

export const verticalConfig: VerticalConfigType = {
  HOME: {
    fullName: '쇼핑홈',
    subVerticals: [SubVertical.HOME],
    homeUrl: {
      mobile: '/home/m/index.nhn',
      pc: '/home/p/index.nhn',
    },
  },
  DEPARTMENT: {
    subVerticals: [SubVertical.DEPARTMENT],
    isWindow: true,
  },
  OUTLET: {
    subVerticals: [SubVertical.OUTLET],
    isWindow: true,
  },
  STYLE: {
    subVerticals: [SubVertical.STYLE, SubVertical.FASHION_BRAND],
    name: '스타일윈도',
    path: '/style',
    isWindow: true,
  },
  DESIGNER: {
    subVerticals: [SubVertical.DESIGNER],
    isWindow: true,
  },
  BEAUTY: {
    subVerticals: [SubVertical.BEAUTY],
    isWindow: true,
  },
  LIVING: {
    subVerticals: [SubVertical.HOME_LIVING, SubVertical.HANDMADE, SubVertical.STATIONERY],
    name: '리빙윈도',
    path: '/living',
    isWindow: true,
  },
  FRESH: {
    subVerticals: [
      SubVertical.DIRECT_FARM,
      SubVertical.LOCAL_FOOD,
      SubVertical.TRADITIONAL_ALCOHOL,
      SubVertical.HOME_MEAL,
    ],
    name: '푸드윈도',
    path: '/fresh',
    isWindow: true,
  },
  KIDS: {
    subVerticals: [SubVertical.KIDS],
    isWindow: true,
  },
  PET: {
    subVerticals: [SubVertical.PET],
    isWindow: true,
  },
  PLAY: {
    subVerticals: [SubVertical.PLAY],
    isWindow: true,
  },
  ART: {
    subVerticals: [SubVertical.ART],
    isWindow: true,
  },
  HOTDEAL: {
    subVerticals: [SubVertical.SOCIAL, SubVertical.LUCKTO],
    name: '핫딜',
    path: '/hotdeal',
    homeUrl: {
      mobile: '/hotdeal/m/home/index.nhn',
      pc: '/hotdeal/p/index.nhn',
    },
  },
  GIFT: {
    subVerticals: [SubVertical.GIFT],
    isWindow: true,
    path: '/gift',
    homeUrl: {
      mobile: '/gift',
    },
  },
  FOREIGN: {
    fullName: '네이버 해외직구',
    subVerticals: [SubVertical.FOREIGN],
    isWindow: true,
  },
  PLAN: {
    subVerticals: [SubVertical.PLAN],
    homeUrl: {
      mobile: '/plan2/m/index.nhn',
      pc: '/plan2/p/index.nhn',
    },
  },
  BEST: {
    subVerticals: [SubVertical.BEST],
    homeUrl: {
      mobile: '/rank/m/index.nhn',
    },
  },
  SELECTIVE: {
    subVerticals: [SubVertical.SELECTIVE],
    homeUrl: {
      mobile: getSelectiveUrl(),
    },
  },
}

export const getVerticalBySubVertical = (subVerticalName: string): Vertical => {
  if (!subVerticalName) return
  const vertical = Object.keys(verticalConfig).find((vertical: string) =>
    verticalConfig[vertical].subVerticals.includes(subVerticalName.toUpperCase()),
  )

  return Vertical[vertical]
}

export const getVertical = (lowerName: string): Vertical => {
  const vertical = Object.keys(verticalConfig).find(vertical => vertical.toLowerCase() === lowerName)
  return Vertical[vertical]
}

export const getSubVertical = (lowerName: string): SubVertical => {
  const subVertical = Object.keys(subVerticalConfig).find(
    subVertical => subVertical.replace(/_/gi, '').toLocaleLowerCase() === lowerName,
  )
  return SubVertical[subVertical]
}

export const getSubVerticalByVertical = (vertical: Vertical): SubVertical => {
  return verticalConfig[vertical].subVerticals[0]
}

const VERTICAL_INDEX = 1
const SUBVERTICAL_INDEX = 2

const PATH_PATTERN = '/:verticalName?/:subVerticalName?/(.*)*'
const re = pathToRegexp(PATH_PATTERN)

export const getVerticalByPath = (pathname: string): Vertical => {
  const pathParams = re.exec(pathname)
  if (!pathParams || pathParams.length < VERTICAL_INDEX) return
  return getVertical(pathParams[VERTICAL_INDEX])
}

export const getSubVerticalByPath = (pathname: string): SubVertical => {
  const pathParams = re.exec(pathname)
  if (!pathParams || pathParams.length < SUBVERTICAL_INDEX) return
  const subVertical = getSubVertical(pathParams[SUBVERTICAL_INDEX])
  const vertical = getVertical(pathParams[VERTICAL_INDEX])
  if (subVertical && vertical === subVerticalConfig[subVertical].vertical) return subVertical
  if (subVertical === SubVertical.HOME && vertical !== subVerticalConfig[subVertical].vertical) {
    return verticalConfig[vertical].subVerticals[0]
  }
  return (!subVertical && verticalConfig[vertical] && verticalConfig[vertical].subVerticals[0]) || null
}

export const getSubVerticalPath = (subVertical: SubVertical): string => {
  const config = subVerticalConfig[subVertical]
  if (!config) return
  const verticalPath = verticalConfig[config.vertical].path
  return `${verticalPath ? verticalPath : ''}${config.path}`
}
export const getVerticalPath = (vertical: Vertical): string => {
  const config = verticalConfig[vertical]
  if (!config) return
  return config.path || subVerticalConfig[config.subVerticals[0]].path
}

export const getVerticalName = (vertical: Vertical): string => {
  const config = verticalConfig[vertical]
  if (!config) return
  return config.name || subVerticalConfig[config.subVerticals[0]].name
}

export const getVerticalFullName = (vertical: Vertical): string => {
  const config = verticalConfig[vertical]
  if (!config) return
  return config.fullName || config.name || subVerticalConfig[config.subVerticals[0]].name
}

export const getSubVerticalName = (subVertical: SubVertical): string => {
  const config = subVerticalConfig[subVertical]
  if (!config) return
  return config.name
}

export const getParentVerticalName = (subVertical: SubVertical): string => {
  const config = subVerticalConfig[subVertical]
  if (!config) return
  return getVerticalFullName(config.vertical)
}

export const includesSubVertical = (...target: SubVertical[]) => (subVertical: SubVertical): boolean =>
  target.includes(subVertical)
export const excludesSubVertical = (...target: SubVertical[]) => (subVertical: SubVertical): boolean =>
  !target.includes(subVertical)

export const usedRedirectCategoryMenu = (subVertical: SubVertical) => {
  return [SubVertical.DIRECT_FARM, SubVertical.LOCAL_FOOD].includes(subVertical)
}

export const hasNotTabInStore = (subVertical: SubVertical): boolean => {
  return [SubVertical.TRADITIONAL_ALCOHOL, SubVertical.DIRECT_FARM, SubVertical.LOCAL_FOOD].includes(subVertical)
}

export const isCircleRepImageShown = (subVertical: SubVertical): boolean => {
  return [SubVertical.DIRECT_FARM, SubVertical.LOCAL_FOOD].includes(subVertical)
}

export const isWindowService = (path: string): boolean => {
  const vertical = getVerticalByPath(path)
  return verticalConfig[vertical] && verticalConfig[vertical].isWindow
}

export const isReactHome = (vertical: Vertical) => {
  return [
    Vertical.DEPARTMENT,
    Vertical.OUTLET,
    Vertical.STYLE,
    Vertical.LIVING,
    Vertical.ART,
    Vertical.FRESH,
    Vertical.FOREIGN,
    Vertical.GIFT,
  ].includes(vertical)
}

// vertical별 Home기준 -> 공통 LNB 상단 고정 스타일 사용안하도록
export const isNotUseLnbFixed = (vertical: Vertical, subVertical: SubVertical, pathname: string): boolean => {
  if (!pathname.includes('/home')) return true
  if ([SubVertical.DIRECT_FARM, SubVertical.LOCAL_FOOD].includes(subVertical)) return true
  return [Vertical.DEPARTMENT, Vertical.OUTLET].includes(vertical)
}

export const isCategoryProductsShown = (subVertical: SubVertical): boolean => {
  return ![
    SubVertical.DEPARTMENT,
    SubVertical.OUTLET,
    SubVertical.STYLE,
    SubVertical.LOCAL_FOOD,
    SubVertical.TRADITIONAL_ALCOHOL,
    SubVertical.DIRECT_FARM,
  ].includes(subVertical)
}

export const isMatchedOtherProductsShown = (subVertical: SubVertical): boolean => {
  return [SubVertical.OUTLET].includes(subVertical)
}

export const isShownStoreNews = (subVertical: SubVertical): boolean => {
  return [SubVertical.LOCAL_FOOD, SubVertical.DIRECT_FARM, SubVertical.TRADITIONAL_ALCOHOL].includes(subVertical)
}

export const isDiscountRateShown = (subVertical: SubVertical): boolean => {
  return ![SubVertical.DEPARTMENT, SubVertical.STYLE].includes(subVertical)
}

export const isEvaluateShown = (subVertical: SubVertical): boolean => {
  return [SubVertical.PLAY].includes(subVertical)
}

export const isLookBookShown = (subVertical: SubVertical): boolean => {
  return [SubVertical.FASHION_BRAND].includes(subVertical)
}

export const isSoldOutToastShown = (subVertical: SubVertical): boolean => {
  return [SubVertical.OUTLET].includes(subVertical)
}

export const isAiTemsShown = (subVertical: SubVertical): boolean => {
  return [SubVertical.DEPARTMENT, SubVertical.OUTLET, SubVertical.STYLE].includes(subVertical)
}

export const usedReactHome = (subVertical: SubVertical): boolean => {
  return [
    SubVertical.DEPARTMENT,
    SubVertical.OUTLET,
    SubVertical.STYLE,
    SubVertical.HOME_LIVING,
    SubVertical.HANDMADE,
    SubVertical.STATIONERY,
    SubVertical.ART,
    SubVertical.HOME_MEAL,
    SubVertical.FOREIGN,
    SubVertical.TRADITIONAL_ALCOHOL,
    SubVertical.DIRECT_FARM,
    SubVertical.LOCAL_FOOD,
  ].includes(subVertical)
}

export const isRecommendedTagShown = (subVertical: SubVertical): boolean => {
  return [SubVertical.STYLE].includes(subVertical)
}

export const hasMultipleSubVerticals = (vertical: Vertical): boolean => {
  return verticalConfig[vertical].subVerticals.length > 1
}

export const isEnabledNewCard = excludesSubVertical(SubVertical.DESIGNER, SubVertical.FASHION_BRAND)
export const isEnabledRelationProductCard = includesSubVertical(SubVertical.DEPARTMENT, SubVertical.STYLE)
export const isEnabledPremiumReviewCard = includesSubVertical(SubVertical.PET)
export const isEnabledShortcutCard = excludesSubVertical(
  SubVertical.DESIGNER,
  SubVertical.FASHION_BRAND,
  SubVertical.HOME_MEAL,
  SubVertical.TRADITIONAL_ALCOHOL,
)

export const isEnabledRankingCard = includesSubVertical(SubVertical.DEPARTMENT, SubVertical.OUTLET)

export const isEnabledSpecialEvent = excludesSubVertical(SubVertical.HOME_MEAL, SubVertical.TRADITIONAL_ALCOHOL)

export const isEnabledFreshNews = includesSubVertical(SubVertical.HOME_MEAL, SubVertical.TRADITIONAL_ALCOHOL)

export const isEnabledFreshReview = includesSubVertical(SubVertical.HOME_MEAL, SubVertical.TRADITIONAL_ALCOHOL)

export const isEnabledFreshEvent = includesSubVertical(SubVertical.HOME_MEAL, SubVertical.TRADITIONAL_ALCOHOL)

export const isShownRepurchaseBenefitProduct = includesSubVertical(SubVertical.DIRECT_FARM, SubVertical.LOCAL_FOOD)

export const isUsingCustomFilterAndSort = includesSubVertical(
  SubVertical.DEPARTMENT,
  SubVertical.OUTLET,
  SubVertical.STYLE,
  SubVertical.ART,
  SubVertical.FOREIGN,
  SubVertical.TRADITIONAL_ALCOHOL,
  SubVertical.HOME_MEAL,
  SubVertical.DIRECT_FARM,
  SubVertical.LOCAL_FOOD,
)

export const isUsing1stMenuInsteadOfRootId = includesSubVertical(
  SubVertical.HOME_LIVING,
  SubVertical.HANDMADE,
  SubVertical.STATIONERY,
  SubVertical.HOME_MEAL,
)

export const isFashionMall = includesSubVertical(SubVertical.DEPARTMENT, SubVertical.OUTLET)

export const usedCompositeMenu = includesSubVertical(SubVertical.FOREIGN)

export const isUsingCompositeMenuBySubVertical = includesSubVertical(SubVertical.FOREIGN)

export const includeStoreInfoWithHighRatingReview = includesSubVertical(SubVertical.DIRECT_FARM, SubVertical.LOCAL_FOOD)
